import { OrderInfoSchema } from "./OrderSchema"


export function OrderItem({item, isSelected, viewMode,showCustomer, onClick, onCheckChange }: { item: OrderInfoSchema, isSelected:boolean,viewMode:number, showCustomer:boolean, onClick: (id: string) => void, onCheckChange: (id: string, checked: boolean) => void}) {


  
  return (
    <tr key={item.orderId} className="border-t hover:bg-gray-100 cursor-pointer dark:bg-zinc-700 dark:hover:bg-zinc-600" onClick={() => onClick(item.orderId  )}>
      {showCustomer && (
      <td className="px-4 py-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onCheckChange(item.orderId, e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        />
      </td>
      )}
      { /*showCustomer && */ }
      <td>
      {viewMode === 1 && <div className="px-4 py-2">{item.site}</div>}
      {viewMode === 2 && <div className="px-4 py-2">{item.customer}</div>}
      {item.error && <div className="px-4 py-2 text-red-600 font-bold" >{item.error}</div>}
      </td>

      <td className="px-4 py-2">{item.orderName}</td>
      <td className="px-4 py-2 min-w-[120px]">{new Intl.DateTimeFormat("de-DE", {day:"2-digit",month:"2-digit",year:"numeric",}).format(new Date(item.orderBegin))} </td>
      <td className="px-4 py-2 min-w-[120px]">{new Intl.DateTimeFormat("de-DE", {day:"2-digit",month:"2-digit",year:"numeric",}).format(new Date(item.orderEnd))} </td>
      <td className="px-4 py-2 text-center">{item.rotation}</td>
      <td className="px-4 py-2 text-center">{item.orderLength}s</td>
      {/* <td className="px-4 py-2">{item.category}</td> */}
      {showCustomer && (
      <td className="px-4 py-2">{item.container}</td>
      )}
    </tr>
    
  )
}